import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import '../styles/WhoIWorkWith.css';

const WhoIWorkWith = () => {
  const idealClients = [
    {
      id: 'dtc-ecommerce',
      title: 'DTC & eCommerce Brands',
      description: 'Scaling customer acquisition profitably through paid media, improving attribution accuracy, and reducing CAC while maintaining or improving ROAS.'
    },
    {
      id: 'b2b-companies',
      title: 'B2B Companies',
      description: 'Generating qualified leads through LinkedIn Ads, Google Ads, and programmatic channels. Building attribution models that connect marketing spend to pipeline revenue.'
    },
    {
      id: 'scaling-brands',
      title: 'Brands Scaling Paid Media',
      description: 'Breaking through growth plateaus with advanced bidding strategies, creative testing frameworks, and data infrastructure that supports scale without waste.'
    },
    {
      id: 'attribution-challenges',
      title: 'Teams Struggling with Attribution',
      description: 'Fixing broken tracking, implementing GA4 and server-side GTM correctly, and building Marketing Efficiency Ratio (MER) frameworks for true performance visibility.'
    },
    {
      id: 'founders-cmos',
      title: 'Founders, CMOs & Growth Leaders',
      description: 'Providing strategic consulting for marketing leadership teams who need a specialist operator to audit systems, design roadmaps, and execute high-impact changes.'
    },
    {
      id: 'ai-integration',
      title: 'Businesses Needing AI Integration',
      description: 'Deploying AI for predictive analytics, automated personalization, and intelligent campaign optimization to achieve growth beyond traditional manual tactics.'
    }
  ];

  return (
    <section id="who-i-work-with" className="who-i-work-with">
      <div className="who-container">
        <div className="who-header reveal">
          <div className="section-label">Ideal Client Fit</div>
          <h2 className="section-title">Who I Work With</h2>
          <div className="title-underline"></div>
          <p className="who-subtitle">
            As a performance marketing and growth marketing consultant, I work best with businesses that are ready to invest in data-driven growth infrastructure.
          </p>
        </div>
        
        <div className="who-grid">
          {idealClients.map((client) => (
            <div key={client.id} className="who-card reveal">
              <div className="who-icon">
                <CheckCircle2 size={24} className="check-icon" />
              </div>
              <h3 className="who-title">{client.title}</h3>
              <p className="who-description">{client.description}</p>
            </div>
          ))}
        </div>

        <div className="who-cta reveal">
          <p className="who-cta-text">
            Not sure if we're a fit?{' '}
            <strong>
              <a
                href="#contact"
                data-testid="lets-talk-link"
                className="who-cta-link"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Let's talk.
              </a>
            </strong>{' '}
            Book a 30-minute strategy call to discuss your growth challenges.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoIWorkWith;
